import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.1 8.99H7a5 5 0 1 0 0 10h1.5a.5.5 0 0 1 0 1H7a6 6 0 1 1 0-12h14.035L15.888 3.97a.5.5 0 0 1 .616-.788l6.23 4.867A.5.5 0 0 1 23 8.49v.004a.498.498 0 0 1-.194.401l-6.209 5.028a.5.5 0 1 1-.629-.777L21.1 8.99z"
});

var SvgRefund = function SvgRefund(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgRefund;